"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "NVIDIA",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/partner_logo_nvidia.png"
}, {
  name: "Intel",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/partner_logo_intel.png"
}, {
  name: "Logitech",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/partner_logo_logitech.png"
}, {
  name: "Razer",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/partner_logo_razer.png"
}, {
  name: "Samsung",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/partner_logo_samsung.png"
}, {
  name: "Sony",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/partner_logo_sony.png"
}, {
  name: "Asus",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/partner_logo_asus.png"
}, {
  name: "Microsoft",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/partner_logo_microsoft.png"
}];
export default function EcosystemPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="74285" id="industry-partners" className="bg-background text-foreground border-y border-border py-16 md:py-24 overflow-hidden relative">
      {}
      <style>{`
        @keyframes infinite-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-infinite-scroll {
          animation: infinite-scroll 40s linear infinite;
          width: max-content;
        }
        .animate-infinite-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div ref={ref} className={`container mx-auto px-4 mb-12 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4 tracking-tight">
          Industry Partners
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
          ApexRig Tech collaborates with global tech leaders and premium manufacturers to ensure every product meets our high standards of performance and reliability.
        </p>
      </div>

      {}
      <div className="relative flex overflow-hidden w-full before:absolute before:left-0 before:top-0 before:z-10 before:h-full before:w-24 before:bg-gradient-to-r before:from-background before:to-transparent after:absolute after:right-0 after:top-0 after:z-10 after:h-full after:w-24 after:bg-gradient-to-l after:from-background after:to-transparent">
        
        <div className="flex animate-infinite-scroll items-center">
          {}
          {partners.map((partner, i) => <div key={`set1-${i}`} data-index={i} className="mx-8 md:mx-16 flex items-center justify-center shrink-0">
              <img src={partner.logo} alt={`${partner.name} logo`} className="h-12 md:h-16 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 hover:scale-105 transition-all duration-300 cursor-pointer drop-shadow-sm" />
            </div>)}
          
          {}
          {partners.map((partner, i) => <div key={`set2-${i}`} data-index={i} className="mx-8 md:mx-16 flex items-center justify-center shrink-0">
              <img src={partner.logo} alt={`${partner.name} logo`} className="h-12 md:h-16 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 hover:scale-105 transition-all duration-300 cursor-pointer drop-shadow-sm" />
            </div>)}
        </div>

      </div>
    </section>;
}